import Axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { Button, Col, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import DashboardContext from '../../../Context';
import InputClock from '../../inputs/InputClock';
import InputControl from '../../inputs/InputControl';
import InputDate from '../../inputs/InputDate';
import InputNumber from '../../inputs/InputNumber';
import InputPricing from '../../inputs/InputPricing';
import Loader from '../../layout/Loader';

const ModalJobSituation = ({
  sohwitem,
  handelClosemodal,
  id,
  handeldeleteitem,
}) => {
  const { authentication, urldashboard } =
    useContext(DashboardContext);

  const [lodingData, setLodingData] = useState(true);

  const [dataUpdate, setDataUpdate] = useState({});

  const [formdata, setFormdata] = useState({});

  const [dataModalConfirmation, setDataModalConfirmation] = useState({});

  const [LoadingForm, setLoadingForm] = useState(false);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const handelLoadingform = (item) => setLoadingForm(item);

  const handelsetdataForm = (item) => setFormdata(item);

  const handelValue = (name, value) => {
    switch (name) {
      case 'type':
        handelsetdataForm({ ...formdata, type: value });
        break;
      case 'startClock':
        const lastdataStartDate = formdata.startWork
          ? formdata.startWork.substr(0, 10)
          : '';
        handelsetdataForm({
          ...formdata,
          startWork: `${lastdataStartDate}T${value}`,
        });
        break;
      case 'endClock':
        const lastdataEndDate = formdata.endWork
          ? formdata.endWork.substr(0, 10)
          : '';
        handelsetdataForm({
          ...formdata,
          endWork: `${lastdataEndDate}T${value}`,
        });
        break;
      case 'startWork':
        const clockStart = formdata.startWork
          ? formdata.startWork.substr(11, 16)
          : '00:00';
        handelsetdataForm({ ...formdata, startWork: `${value}T${clockStart}` });
        break;
      case 'endWork':
        const clockEnd = formdata.endWork
          ? formdata.endWork.substr(11, 16)
          : '00:00';
        handelsetdataForm({ ...formdata, endWork: `${value}T${clockEnd}` });
        break;
      case 'amount':
        handelsetdataForm({ ...formdata, amount: parseInt(value) });
        break;

      default:
        break;
    }
  };

  const dataFeching = async () => {
    try {
      const res = await Axios.get(
        `${urldashboard}/workerorderschedule/updatetype/${id}`,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = await res.data.data;
      setDataUpdate(data);
      setFormdata(data);
      setLodingData(false);
    } catch (error) {
      handelError(error);
    }
  };

  const handelError = (error) => {
    if (error.message === 'Network Error') {
      toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLodingData(false);
    } else {
      if (error.response) {
        toast.error(error.response.data.message, {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setLodingData(false);
        handelClosemodal();
      }
    }
  };

  useEffect(() => {
    if (id) {
      dataFeching();
    }
    return () => {};
  }, []);

  const putData = async (isEmergency) => {
    handelLoadingform(true);
    try {
      const res = await Axios.put(
        isEmergency
          ? `${urldashboard}/workerorderschedule/updatetypeemergency`
          : `${urldashboard}/workerorderschedule/updatetype`,
        JSON.stringify({
          id: formdata.id,
          type: formdata.type,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = await res.data;
      handelLoadingform(false);
      handeldeleteitem();
      toast.success(data.message, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      handelError(error);
      handelLoadingform(false);
    }
  };

  const postUpdate = async () => {
    handelLoadingform(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/workerorderschedule/pricecalculation`,
        JSON.stringify({
          id: formdata.id,
          startWork: formdata.startWork,
          endWork: formdata.endWork,
          amount: formdata.amount,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );

      const data = await res.data.data;
      setDataModalConfirmation(data);
      setShow(true);
      handelLoadingform(false);
    } catch (error) {
      handelError(error);
    }
  };

  const handelSubmit = (event) => {
    event.preventDefault();
    handelLoadingform(true);
    if (formdata.type === 4) {
      postUpdate();
    } else {
      putData();
    }
  };

  const handelvalueMoldal = (name, value) => {
    switch (name) {
      case 'paymentType':
        setDataModalConfirmation({
          ...dataModalConfirmation,
          paymentType: parseInt(value),
        });
        break;
      case 'confirmCode':
        setDataModalConfirmation({
          ...dataModalConfirmation,
          confirmCode: value,
        });
        break;

      default:
        break;
    }
  };
  const handelSubmitModal = () => {
    handelLoadingform(true);
    if (!dataModalConfirmation.confirmCode) {
      handelLoadingform(false);
      toast.error('کد تایید اجباری است', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      sendmodal();
    }
  };

  const sendmodal = async () => {
    handelLoadingform(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/workerorderschedule/confirmtask`,
        JSON.stringify(dataModalConfirmation),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = await res.data;

      toast.success(data.message, {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      handelLoadingform(false);
      handeldeleteitem();
      handelClosemodal();
      setShow(false);
    } catch (error) {
      handelError(error);
    }
  };

  return (
    <Modal show={sohwitem} onHide={handelClosemodal} size='lg'>
      <Modal.Header>
        <Modal.Title>تغییر وضعیت کار نیرو</Modal.Title>
        <i
          className='fa fa-times mr-auto'
          style={{ fontSize: '16px', cursor: 'pointer' }}
          onClick={handelClosemodal}
          aria-hidden='true'
        ></i>
      </Modal.Header>
      <Modal.Body>
        <>
          {lodingData ? (
            <Loader />
          ) : (
            <Form>
              <Form.Row>
                <Col>
                  <InputControl
                    url='/common/workerorderscheduletypedropdown/false'
                    label='وضعیت کار'
                    name='type'
                    handelValue={handelValue}
                    defaultValue={dataUpdate.type}
                    filteredElement={3}
                  />
                </Col>
                <Col>
                  <InputPricing
                    name='amount'
                    handelValue={handelValue}
                    label='هزینه ها'
                    disabled={
                      formdata.hasOwnProperty('type')
                        ? formdata.type === 4
                          ? false
                          : true
                        : false
                    }
                  />
                </Col>
              </Form.Row>
              <Form.Row>
                <Col>
                  <InputDate
                    label='تاریخ شروع'
                    handelValue={handelValue}
                    name='startWork'
                    disabled={
                      formdata.hasOwnProperty('type')
                        ? formdata.type === 4
                          ? false
                          : true
                        : false
                    }
                    defaultValue={
                      dataUpdate.hasOwnProperty('startWork')
                        ? dataUpdate.startWork.split('T')[0]
                        : ''
                    }
                  />
                </Col>
                <Col>
                  <InputClock
                    label='ساعت شروع'
                    handelValue={handelValue}
                    name='startClock'
                    disabled={
                      formdata.hasOwnProperty('type')
                        ? formdata.type === 4
                          ? false
                          : true
                        : false
                    }
                    defaultValue={
                      dataUpdate.hasOwnProperty('startWork')
                        ? dataUpdate.startWork.split('T')[1]
                        : ''
                    }
                  />
                </Col>
                <Col>
                  <InputDate
                    label='تاریخ پایان'
                    handelValue={handelValue}
                    name='endWork'
                    disabled={
                      formdata.hasOwnProperty('type')
                        ? formdata.type === 4
                          ? false
                          : true
                        : false
                    }
                    defaultValue={
                      dataUpdate.hasOwnProperty('endWork')
                        ? dataUpdate.endWork.split('T')[0]
                        : ''
                    }
                  />
                </Col>
                <Col>
                  <InputClock
                    label='ساعت پایان'
                    name='endClock'
                    disabled={
                      formdata.hasOwnProperty('type')
                        ? formdata.type === 4
                          ? false
                          : true
                        : false
                    }
                    handelValue={handelValue}
                    defaultValue={
                      dataUpdate.hasOwnProperty('endWork')
                        ? dataUpdate.endWork.split('T')[1]
                        : ''
                    }
                  />
                </Col>
              </Form.Row>
              <Form.Row>
                <Col lg={12} xs={12}>
                  <button
                    type='submit'
                    className='btn btn-success'
                    onClick={handelSubmit}
                    disabled={LoadingForm}
                  >
                    {LoadingForm ? (
                      <i className='fa fa-spinner fa-pulse fa-fw'></i>
                    ) : formdata.type === 4 ? (
                      'محاسبه قیمت'
                    ) : (
                      'ثبت'
                    )}
                  </button>
                </Col>
              </Form.Row>
            </Form>
          )}
          <Modal show={show} onHide={handleClose}>
            <Modal.Header>
              <Modal.Title>تایید کار</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col lg='12' md='12' sm='12' xs='12'>
                <p>{dataModalConfirmation.message}</p>
                <Col>
                  <InputNumber
                    label='قیمت جدید'
                    disabled
                    defaultValue={new Intl.NumberFormat('ja-JP', {
                      maximumSignificantDigits: 12,
                    }).format(dataModalConfirmation.newPrice)}
                    name='newPrice'
                    handelValue={handelvalueMoldal}
                  />
                </Col>
              </Col>
              <Col>
                <InputNumber
                  label='کد تایید'
                  defaultValue={dataModalConfirmation.confirmCode}
                  name='confirmCode'
                  handelValue={handelvalueMoldal}
                />
              </Col>
              <Col>
                <InputControl
                  label='وضعیت پرداخت'
                  url='/common/paymenttypedropdown'
                  name='paymentType'
                  defaultValue={dataModalConfirmation.paymentType}
                  handelValue={handelvalueMoldal}
                />
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                disabled={LoadingForm}
                className='ml-auto'
                variant='danger'
                onClick={handleClose}
              >
                {' '}
                بستن
              </Button>
              <Button
                disabled={LoadingForm}
                variant='success'
                onClick={handelSubmitModal}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : (
                  'تایید'
                )}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      </Modal.Body>
    </Modal>
  );
};

export default ModalJobSituation;
